/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComplianceChecklist } from './ComplianceChecklist';
import {
    ComplianceChecklistFromJSON,
    ComplianceChecklistFromJSONTyped,
    ComplianceChecklistToJSON,
    ComplianceChecklistToJSONTyped,
} from './ComplianceChecklist';

/**
 * 
 * @export
 * @interface PaginatedComplianceChecklistList
 */
export interface PaginatedComplianceChecklistList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedComplianceChecklistList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedComplianceChecklistList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedComplianceChecklistList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ComplianceChecklist>}
     * @memberof PaginatedComplianceChecklistList
     */
    results: Array<ComplianceChecklist>;
}

/**
 * Check if a given object implements the PaginatedComplianceChecklistList interface.
 */
export function instanceOfPaginatedComplianceChecklistList(value: object): value is PaginatedComplianceChecklistList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedComplianceChecklistListFromJSON(json: any): PaginatedComplianceChecklistList {
    return PaginatedComplianceChecklistListFromJSONTyped(json, false);
}

export function PaginatedComplianceChecklistListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedComplianceChecklistList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ComplianceChecklistFromJSON)),
    };
}

  export function PaginatedComplianceChecklistListToJSON(json: any): PaginatedComplianceChecklistList {
      return PaginatedComplianceChecklistListToJSONTyped(json, false);
  }

  export function PaginatedComplianceChecklistListToJSONTyped(value?: PaginatedComplianceChecklistList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(ComplianceChecklistToJSON)),
    };
}

